<template>
    <div class="news-page" @scroll="bingsrcoll">
        <!-- 正文 -->
        <div class="hidden-sm-and-down">
            <div class="first-page">
                <img v-if="aboutusData.children[0].requestType.indexOf('image')>-1" :src="aboutusData.children[0].requestPath" :alt="aboutusData.dictLabel" style="width:100%;height:calc(100% - 60px);">
                <div v-else style="width: 100%;height:100%;">
                    <video class="header-video" id="aboutvideo" width="100%" height="100%" name="media" muted loop>
                        <source  :src="aboutusData.children[0].requestPath" type="video/mp4">
                        <span v-if="this.isEn != '1'">您的浏览器不支持 video 标签。</span>
                        <span v-if="this.isEn == '1'">The browser does not support video tags。</span>
                    </video>
                </div>
                 <div class="first-page-titlepart">
                        <div class="first-page-title" >{{aboutusData.children[0].title}}</div>
                        <div class="first-page-titlebottom"></div>
                        <!-- <div class="first-page-titledesc">德卡科技引领行业动态</div> -->
                        <div  v-if="videoAll&&videoAll[0]&&videoAll[0].title=='观看全部视频'" @click="openVideoShow" style="text-align: left;font-size: 22px;cursor: pointer;">
                            <i class="el-icon-video-play" style="font-weight: inherit;font-size: 30px;vertical-align: text-top;margin-right: 2px;"></i>
                          <span v-if="this.isEn != '1'">观看全部视频</span>
                          <span v-if="this.isEn == '1'">Watch all videos。</span>
                        </div>
                        <pre v-else class="first-page-titledesc">{{aboutusData.children[0].content}}</pre>
                 </div>
            </div>
            <div class="about-content row">
                <div class="row col-md-90" style="padding-left:0px;padding-right:0px;">
                    <div class="news-content-title" style="padding-left: 0;display: flex;justify-content: space-between;">
                        <div v-if="isEn ==='0'">德卡科技最新资讯</div>
                        <div v-else-if="isEn === '1'">The latest news of Decard Technology</div>
                        <div v-if="morebuttons.length > 4 && isEn ==='0'" style="font-size: 16px;color: #838383;cursor: pointer;" @click="moreClick">
                            更多></div>
                        <div v-if="morebuttons.length > 4 && isEn ==='1'" style="font-size: 16px;color: #838383;cursor: pointer;" @click="moreClick">
                          More></div>
                    </div>

                    <div class="news-item row news-content" v-for="(item,index) in news_list" :Key="index" @click="news_listClick(item)">
                        <div style="width: 100%;height:100%;padding-legt:10px;padding-right:10px;">
                            <div class="sceneTopList" style="height:calc(100% - 122px)">
                            <img :src="item.picUrl" :alt="item.title" style="height:100%">
                            </div>
                            <!-- class="col-md-90" -->
                            <div class="describe-content" style="height:92px">
                                <div class="describe-date-content">{{item.publishTime}}</div>
                                <div class="describe-main-content">{{item.title}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <videoCommon ref="videoProp" v-if="videoAll[0]" :videoTitle="videoAll[0].title" :videoUrl="videoAll[0].requestPath"></videoCommon>
            <home-foot></home-foot>
        </div>


        <div class="visible-sm-and-down">
            <div class="first-page">
                <img src="../assets/mobile/news01_img.jpg" alt="新闻动态" style="width:100%;">
            </div>
            <div class="about-content row" style="margin-right: 0;margin-left: 0;">
                <div class="row no-padding" style="padding-left:0px;padding-right:0px;">
                    <div class="mobile-content" style="margin-bottom:0px;">
                        <div class="mobile-content-title" style="padding-left: 0;display: flex;justify-content: space-between;">
                            <div>德卡科技最新资讯</div>
                             <div v-if="morebuttons.length > 4" style="font-family: PingFangSC-Regular;font-size: 14px;color: #00ACF5;letter-spacing: 0;text-align: left;line-height: 20px;" @click="moreClick">
                            更多</div>
                        </div>
                        <div class="mobile-content-main" style="padding-top: ;">
                            <div class="news-item row no-padding" v-for="(item, index) in news_list" :Key="index" style="height:294px"
                                @click="news_listClick(item)">
                                <div style="width: 100%;height:calc(100% - 92px)">
                                    <!-- class="col-md-90" -->
                                    <img :src="item.picUrl" :alt="item.title" style="height:100%">
                                    <div class="describe-content" style="width:100%;height: 80px;">
                                        <div class="describe-main-content" style="font-size: 16px;margin-bottom: 10px;">{{ item.title }}</div>
                                        <div class="describe-date-content">{{ item.publishTime }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <home-foot></home-foot>
        </div>

    </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot";
import videoCommon from "@/components/videoCommon";

export default {
    name: "news",
    components:{
        HomeFoot,
        videoCommon
    },
    created(){
        window.scrollTo(0,0);
        this.$picData.map((item) => {
            if (item.dictCode == 152) {
                this.aboutusData = item
            }
        })
        this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0')
    },
    mounted(){
        // Animationjs.init();
        // $(window).scrollTop(0)
        $('.news-page').animate({ scrollTop:0 }, 600);

        var videoid =  document.getElementById('aboutvideo');
        if(videoid){
            var windowWidth = $(window).width();
            if(windowWidth < 991){
                videoid.autoplay=false;
            }else if(windowWidth >= 991){
                videoid.autoplay=true;
            }
        }
        this.getNews();
        this.videoAll = this.aboutusData.children.filter(t=> t.title=="观看全部视频");

    },
    data() {
        return {
            scroll_Value:0,
            aboutusData:{}, //关于我们
            SVGoption:{
                Size:[500,500],
                circle_list:[
                    {size:[500,500],position:[250,250],background:"rgb(228, 188, 188)",r:"250"},
                    {size:[500,500],position:[300,250],background:"green",r:"200",animate:{dur:"4s"},from:"0 250 250",to:"360 250 250",begin:"0s"},
                    {size:[500,500],position:[250,250],background:"blue",r:"150",animate:{dur:"3s"},from:"0 250 250",to:"360 250 250",begin:"0s"},
                    {size:[250,250],position:[300,250],background:"red",r:"100",animate:{dur:"4s"},from:"0 250 250",to:"360 250 250",begin:"1s"},
                    {size:[100,100],position:[250,250],background:"yellow",r:50,animate:{dur:"5s"}},
                ],
            },
            remindPosition:[0,0],
            svgRemindShow:false,
            morebuttons: [],


            // 正文
            news_list:[
                // {date:"2019.8.15",label:"德卡携金融方案支持中国移动金融发展大会",imgPath:"/static/link/img/news/news2_img.jpg"},
                // {date:"2019.8.15",label:"金融与社保强需求牵引，农村地区存在巨大终端市场,金融与社保强需求牵引，农村地区存在巨大终端市场",imgPath:"/static/link/img/news/news3_img.jpg"},
                // {date:"2019.8.15",label:"西安市本月底完成公交车刷卡机改造 可扫码支付",imgPath:"/static/link/img/news/news4_img.jpg"},
                // {date:"2019.8.15",label:"福州电子社保卡上线 人社服务从“卡时代”迈进“码时代”",imgPath:"/static/link/img/news/news5_img.jpg"},
            ],
            videoAll:"",
            isEn: '0',
        };
    },
    methods:{
        svgMove(e){
            this.$refs.svgContentView.pauseAnimations()
            e=e || window.event
            this.svgRemindShow=true
            this.remindPosition=[e.screenX+"px",e.screenY+"px"]
        },
        svgLeave(){
            this.$refs.svgContentView.unpauseAnimations()
            this.svgRemindShow=false
        },
        bingsrcoll(e) {
            this.scroll_Value = e.srcElement.scrollTop;
        },
        // 正文
        openVideoShow(){
            this.$refs.videoProp.openVideoShow();
        },
        getNews(){
            this.news_list = [];
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/news/list?isEn=`+this.isEn, {  }
            ).then((response)=>{
                var res=response.data
                if(res.code== 200){
                    this.morebuttons = res.rows
                    this.news_list = res.rows.slice(0, 4)
                }else{

                }
            }).catch(res => {

            })
        },
         news_listClick(e) {
            if (this.isEn == '1'){
              this.$router.push({name:"newsDetail_en",query:{uuid:e.uuid,type:'1'}})
            } else{
              this.$router.push({name:"newsDetail",query:{uuid:e.uuid,type:'1'}})
            }

        },
        moreClick() {
          if (this.isEn == '1'){
            this.$router.push({name:'newsList_en'});
          } else{
            this.$router.push(`/newsList`);
          }
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.sceneTopList {
    cursor: pointer;
    overflow: hidden;
    img {
        transform: scale(1);
        transition: all .3s linear;
        // min-height: 100%;
    }
}
.describe-content{
     cursor: pointer;
}
.sceneTopList>img:hover {
    transform: scale(1.1);
    transition: all .3s linear;
    // overflow: hidden;
}

.news-page{
    /* margin-top: 60px; */
    /* overflow: auto; */
    height: 100%;
}
 .news-page .hidden-sm-and-down{
    height: 100%;
}
.svgcontent .circle-node{
    position:relative;
}
.content{
    margin:100px 50px;
    width:500px;
    height:500px;
    border-radius: 50%;
    overflow: hidden;
}
.svgRemind{
    position:fixed;
    color:red;
}
.svg-copy{
    width:500px;
    height:500px;
    border-radius: 50%;
    position:absolute;
    left:0;
    top:0;
    opacity:0;
    z-index:1000;
}




/* 正文 */
/* .first-page {
   min-height: 800px;
   background: url("../assets/img/news1_img.png") no-repeat;
   background-size: 100% 100%;
} */
.first-page {
    /* margin-top: 50px; */
  position: relative;
  height: 100%;
}
/* .first-page-title {
  color: #fff;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -90px;
  margin-left: -120px;
}

.first-page-title > div:nth-child(1) {
  font-size: 64px;
} */
.first-page-titlepart{
    color: #fff;
    text-align: left;
    position: absolute;
    top: 40%;
    left: 15%;
    font-size: 64px;
    margin-top: -22px;
}
.first-page-title{
    font-size: 48px;
    font-weight: 600;
}
.first-page-titlebottom{
    width:68px;
    border:1.5px solid #fff;
    margin:15px 0;
    border-radius: 5px;
    background: #fff;
}
.first-page-titledesc{
    font-size: 22px;
    color: #fff;
    font-weight: normal;
}

.about-content > div {
  /* min-width: 900px; */
  /* max-width: 1600px; */
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 50px;
}
.news-content-title {
    font-size: 28px;
    color: #2C2C2C;
    width: 100%;
    margin-bottom: 50px;
    padding-left: 25px;
    font-weight: 600px;
}

.about-content .news-item{
    margin-bottom: 72px;
    width: 47.5%;
}
.about-content .news-item>div{
    margin: 0 auto;
}
.about-content .news-item>div img{
    width: 100%;
    object-fit: cover;
}
.about-content .news-item .describe-content{
    margin-top: 30px;
}
.news-item .describe-content .describe-date-content{
    font-size: 16px;
    color: #838383;
    line-height: 16px;
    margin-bottom: 10px;
}
.news-item .describe-content .describe-main-content{
    font-size: 20px;
    color: #202020;
    line-height: 36px;
    overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;  //使用自适应布局
	-webkit-line-clamp: 2;  //设置超出行数，要设置超出几行显示省略号就把这里改成几
	-webkit-box-orient: vertical;
}
.hidden-sm-and-down .about-content .news-item:nth-child(even){
    margin-right: 5%;
}


/*  小屏适应性配置  */
@media only screen and (max-width:991px) {
    .first-page {
        margin-top: 50px;
    }


/*   手机适应性设置   */
.visible-sm-and-down .about-content{
    padding:0px;
}
.visible-sm-and-down .news-content-title{
    padding-left: 0;
}
.no-padding{
    padding: 0px;
    margin-left: 0px;
    margin-right: 0px;
}
.visible-sm-and-down .news-item .describe-content .describe-main-content{
    font-size: 14px;
    line-height: 26px;
    color: #2c2c2c;
}
.visible-sm-and-down .news-item .describe-content .describe-date-content{
    font-size: 14px;
}
.visible-sm-and-down .about-content > div{
    margin-bottom: 0;
    margin-top: 0;
}
.visible-sm-and-down .about-content .news-item{
    margin-bottom:20px;
    width: 100%;
}
.visible-sm-and-down .news-item .describe-content .describe-date-content{
        margin-bottom: 10px;
}
.about-content .news-item .describe-content{
        margin-top: 12px;
    }
}
.header-video{
    height: -webkit-fill-available;
    width: -webkit-fill-available;
    object-fit: cover;
}
.mobile-content-main{
    margin-top: 26px;
}
.news-content{
    height: 450px;
}

@media screen and (min-width: 1601px) and (max-width: 1700px){
  .news-content{
    height: 400px;
}
}
@media screen and (min-width: 1301px) and (max-width: 1600px){
  .news-content{
    height: 370px;
}
}
/*屏幕在1024px到1199之间（中屏幕电脑）*/

@media screen and (min-width: 1024px) and (max-width:1300px){
 .news-content{
    height: 350px;
}
}
/*屏幕在768px到1023之间（小屏幕-pad）*/
@media screen and (min-width: 801px) and (max-width:1023px){
  .news-content{
    height: 350px;
}
}
@media screen and (min-width: 300px) and (max-width:1024px){
 .about-content .news-item>div img{
    object-fit: contain;
}
}
</style>



// WEBPACK FOOTER //
// src/views/news.vue